<template>
  <v-sheet class="home d-flex justify-center align-center pa-4" style="height: 100%;">
    <v-img 
      max-width="320"
      alt="Checktak" 
      src="./logo.png"
    ></v-img>
  </v-sheet>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HomeView',
  components: {
  }
}
</script>
